import React, { useState, Suspense, lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const ResumeModal = lazy(() => import('./ResumeModal').then(m => ({
  default: m.ResumeModal
})));
export function Hero() {
  const [resumeOpen, setResumeOpen] = useState(false);
  return <section id="home" className="relative min-h-screen flex items-center pt-28 pb-16 overflow-hidden bg-navy text-offwhite" data-id="element-145">
      {/* Abstract Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-146">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-147">
          <defs data-id="element-148">
            <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse" data-id="element-149">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-150" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-151" />
        </svg>
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-navy" data-id="element-152" />
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10 w-full" data-id="element-153">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-154">
          {/* Portrait column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.94,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.15,
          ease: 'easeOut'
        }} className="lg:col-span-5 order-1 flex justify-center lg:justify-start" data-id="element-155">
            <div className="relative w-64 h-80 sm:w-72 sm:h-96 lg:w-full lg:h-[26rem] max-w-sm" data-id="element-156">
              <div className="relative w-full h-full overflow-hidden rounded-2xl bg-navy-light shadow-2xl ring-1 ring-white/10" data-id="element-157">
                <img src="https://cdn.magicpatterns.com/uploads/4vtPTTcnQeusRQ3ASNQ9xd/2098567a-631a-4856-bd70-d92c22037899.jpg" alt="Richard M Oblath, Non-Executive Director and Board Chair" width={448} height={416} loading="eager" fetchPriority="high" decoding="async" className="w-full h-full object-cover object-center" data-id="element-158" />
              </div>
            </div>
          </motion.div>

          {/* Text column */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="lg:col-span-7 order-2" data-id="element-159">
            <div className="flex items-center space-x-4 mb-6" data-id="element-160">
              <div className="h-px w-12 bg-gold" data-id="element-161"></div>
              <span className="text-gold font-medium tracking-widest text-sm uppercase" data-id="element-162">
                Non-Executive Director
              </span>
            </div>

            <h1 className="font-serif text-4xl md:text-6xl font-medium leading-tight mb-6" data-id="element-163">
              Richard M Oblath
              <span className="block text-xl md:text-2xl text-gray-400 mt-4 font-normal" data-id="element-164">
                BSc (Hons), PhD, FIMMM, CEng
              </span>
            </h1>

            <h2 className="text-lg md:text-2xl font-light text-gray-300 mb-8 max-w-2xl leading-relaxed" data-id="element-165">
              40 Years of Global Industrial Leadership
            </h2>

            <p className="text-base md:text-lg text-gray-400 mb-10 max-w-2xl leading-relaxed border-l-2 border-gold/50 pl-6" data-id="element-166">
              Insightful, resilient, and engaging Non-Executive Director
              bringing global oversight expertise across strategy, M&A, risk,
              transformational change, the energy transition, and corporate
              governance.
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap gap-4" data-id="element-167">
              <a href="#board-roles" className="inline-flex justify-center items-center px-8 py-4 bg-gold text-navy font-medium hover:bg-gold-light transition-colors duration-300" data-id="element-168">
                View Board Experience
              </a>
              <a href="#contact" className="inline-flex justify-center items-center px-8 py-4 border border-gray-600 text-offwhite hover:border-gold hover:text-gold transition-colors duration-300" data-id="element-169">
                Get in Touch
              </a>
              <button type="button" onClick={() => setResumeOpen(true)} className="inline-flex justify-center items-center gap-2 px-8 py-4 border border-gold/70 text-gold font-medium hover:bg-gold hover:text-navy transition-colors duration-300" data-id="element-170">
                <BookOpen size={18} data-id="element-171" />
                View Resume
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      {resumeOpen && <Suspense fallback={null} data-id="element-172">
          <ResumeModal open={resumeOpen} onClose={() => setResumeOpen(false)} data-id="element-173" />
        </Suspense>}
    </section>;
}